import { inject, Pipe, PipeTransform } from '@angular/core';
import { PermissionAbilityName } from '@core/enums/permission-ability-names.enum';
import { PermissionsService } from '@core/services/utility/permissions.service';
import { environment } from '@environments/environment';
import { isNull } from 'lodash-es';

@Pipe({
    name: 'permission',
    pure: false,
})
export class PermissionPipe implements PipeTransform {
    private permissionsService = inject(PermissionsService);

    public transform(
        abilityName: string,
        abiltiySection?: PermissionAbilityName,
        riskTypes?: number[],
    ): boolean {
        if (!environment.isPermissionOn) {
            return false;
        }

        switch (abiltiySection) {
            case PermissionAbilityName.Static:
                return !this.permissionsService.getStaticPermission(
                    abilityName,
                );

            case PermissionAbilityName.Risk:
                return !this.permissionsService.getRiskPermission(abilityName);

            case PermissionAbilityName.Actions:
                return !this.permissionsService.getActionPermission(
                    abilityName,
                );

            case PermissionAbilityName.ActionsRo:
                return !this.permissionsService.getActionRoPermission(
                    abilityName,
                );

            case PermissionAbilityName.Risk_Add:
                let riskTypeArr: number[] = [];

                if (!isNull(riskTypes)) {
                    riskTypeArr = riskTypes!;
                }

                return !this.permissionsService.getRiskTypeAddPermissions(
                    riskTypeArr,
                );
            case PermissionAbilityName.Services:
                    return !this.permissionsService.getServicePermission(
                        abilityName,
                    );

            default:
                return !this.permissionsService.getStaticPermission(
                    abilityName,
                );
        }
    }
}
